var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "560px",
    height: "454px",
    viewBox: "0 0 560 454",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agency-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agency-1",
    transform: "translate(-172.000000, -1602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(172.000000, 1602.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 560,
    height: 454
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_polaroid_gg6n",
    transform: "translate(108.000000, 96.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.573868,237.216216 L89.5602893,237.216216 C40.2607486,226.257242 0,188.510869 0,132.064052 C-0.0071231854,123.525512 0.912590227,115.011607 2.74289918,106.673067 L152.67803,82.4301724 L268.343705,63.7297297 C276.653061,69.1862403 284.560242,75.236221 292.003917,81.8327468 L181.289688,124.225427 L129.060865,144.225092 L187.714776,129.591521 L309.454157,99.2195279 C316.849731,107.516445 323.571183,116.3948 329.554002,125.769379 L292.738924,153.398953 L334.333397,133.636822 C334.509406,133.941501 334.684664,134.246683 334.859171,134.552365 C360.956338,180.26484 328.061454,237.216216 275.573868,237.216216 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.474227,50.8566832 C218.241948,56.6468617 183.531283,63.9649239 147.842769,71.5721358 C96.2423413,82.5742223 42.5999241,94.1867355 3.54639175,102.675676 L3.57231934,102.575135 C5.2459955,96.2206438 8.70386554,90.4692802 13.5429918,85.991237 C43.1554482,58.2841611 80.3410372,39.8663269 120.444532,33.043445 L120.44813,33.043445 C132.065715,31.0767267 143.83015,30.0903211 155.615364,30.0945946 C187.099206,30.0506938 218.176758,37.1521313 246.474227,50.8566832 L246.474227,50.8566832 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4639175,0 L35.4639175,262 L292.57732,262 L292.57732,0 L35.4639175,0 Z M268.825505,184.941178 L59.8095256,184.941178 L59.8095256,22.5248856 L268.825505,22.5248856 L268.825505,184.941178 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.169157,68.0168437 C170.754396,57.1938717 158.063301,56.6894751 158.063301,56.6894751 C158.063301,56.6894751 145.696557,55.1103588 137.763364,71.5938778 C130.368998,86.9578666 120.16383,101.792116 136.120416,105.388716 L139.002637,96.4311826 L140.787583,106.055593 C143.059494,106.218754 145.338645,106.257649 147.614814,106.172104 C164.703028,105.621207 180.976988,106.333279 180.452969,100.210356 C179.756408,92.0707972 183.341445,78.4307041 177.169157,68.0168437 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.253806,169.945946 L113.093493,185.012071 C113.093493,185.012071 100.74998,198.27027 109.566777,198.27027 C118.383574,198.27027 121.910297,186.820009 121.910297,186.820009 L148.948454,174.767108 L134.253806,169.945946 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.917889,111.527027 C142.917889,111.527027 124.826155,169.321145 130.569563,172.284944 C136.312972,175.248744 148.948454,177.027027 148.948454,177.027027 L142.917889,111.527027 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.917889,111.527027 C142.917889,111.527027 124.826155,169.321145 130.569563,172.284944 C136.312972,175.248744 148.948454,177.027027 148.948454,177.027027 L142.917889,111.527027 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.14433,185.878378 L159.587629,185.878378 L189.823218,169.945946 C190.489956,170.395911 191.129337,170.888357 191.737701,171.420467 C196.221153,175.349613 199.78098,180.295275 202.14433,185.878378 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 155.154639,
    cy: 82.3175676,
    rx: 15.0721649,
    ry: 15.0472973
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.632043,94.6612567 C154.632043,94.6612567 158.112253,106.233739 154.632043,110.497284 C151.151833,114.760828 173.773196,104.406503 173.773196,104.406503 C173.773196,104.406503 165.652706,92.2249443 167.972846,86.7432432 L154.632043,94.6612567 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.443298,145.452219 L186.204767,153.508229 C186.204767,153.508229 186.829936,155.338327 187.590744,158.004064 C188.581598,161.481843 189.802436,166.383718 190.150425,170.491152 C190.51018,174.657452 189.967593,178.011679 187.384336,178.223515 C183.680473,178.529491 181.751887,180.771517 179.829199,184.108108 L137.164187,184.108108 C137.276246,182.272137 137.411922,180.365523 137.571141,178.405936 C137.659622,177.229018 137.757919,176.036404 137.866033,174.828093 C137.983997,173.439339 142.163136,147.353203 139.022021,141.739046 C132.536159,130.146768 140.791384,123.496811 140.791384,123.496811 C140.791384,123.496811 141.970953,114.669923 141.970953,111.727624 C141.970953,109.420826 151.030031,106.755139 154.946214,105.707663 C155.199815,105.642942 155.423937,105.578213 155.630346,105.531134 C156.308611,105.354601 156.715566,105.254573 156.715566,105.254573 L159.811932,103.989373 C159.811932,103.989373 168.511251,102.312278 169.101038,101.13537 C169.313351,100.711662 169.909038,100.364492 170.610884,100.064371 C171.85532,99.5347364 173.441844,99.1581578 173.81931,98.7815327 C174.358205,98.1632685 174.845418,97.5019851 175.276059,96.8043204 C176.349473,95.4920311 177.882932,94.7035172 179.616901,94.2739178 C185.951177,92.6792152 195.051546,95.8392377 195.051546,95.8392377 L191.866697,116.582424 L187.443298,145.452219 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.954839,132.77027 L185.794527,147.836396 C185.794527,147.836396 173.45101,161.094595 182.267807,161.094595 C191.084605,161.094595 194.611325,149.644337 194.611325,149.644337 L221.649485,137.591436 L206.954839,132.77027 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.635715,66.4707935 L157.223363,60.1891892 L149.435837,61.3566815 C143.790826,62.202976 139.253792,66.2950894 137.992308,71.6780105 L136.536082,77.8918919 L145.364109,77.563844 L147.830328,72.0041496 L147.830328,77.4721925 L151.903785,77.3208105 L154.268049,68.4694749 L155.745692,77.8918919 L170.226804,77.606346 L169.635715,66.4707935 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.505155,96.7886456 L195.585944,95.5945946 C195.585944,95.5945946 236.976814,112.908329 235.810874,127.833964 C234.644933,142.7596 236.393846,142.759596 229.398203,143.356624 C222.402561,143.953651 201.998614,136.789345 202.581583,135.595294 C203.164551,134.401243 207.245355,128.430988 207.245355,128.430988 L191.505155,115.893458 L191.505155,96.7886456 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 169.340206,
    cy: 82.3175676,
    rx: 2.65979381,
    ry: 2.65540541
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.917329,185.878378 C239.802008,185.68054 237.082927,180.913941 236.140249,171.015981 C235.275601,161.935126 235.831587,146.628633 243.392614,125.277322 C257.716754,84.8287163 240.091535,52.1925516 239.91144,51.8674611 L240.780996,51.3378378 C240.826635,51.4202718 245.374634,59.7412127 248.06133,72.9910418 C251.611296,90.5575223 250.31862,108.82242 244.334796,125.645171 C230.035194,166.024742 240.666169,185.140085 240.775107,185.328647 L239.917329,185.878378 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#44D7B6",
    cx: 234.061856,
    cy: 44.2567568,
    rx: 7.09278351,
    ry: 7.08108108
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 255.340206,
    cy: 69.0405405,
    rx: 7.09278351,
    ry: 7.08108108
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#44D7B6",
    cx: 241.154639,
    cy: 84.972973,
    rx: 7.09278351,
    ry: 7.08108108
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#44D7B6",
    cx: 258.886598,
    cy: 99.1351351,
    rx: 7.09278351,
    ry: 7.08108108
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 235.835052,
    cy: 122.148649,
    rx: 7.09278351,
    ry: 7.08108108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.978619,187.648649 C243.978619,187.648649 237.411224,170.451732 257.113402,157.554054 L243.978619,187.648649 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.835052,185.878378 C235.835052,185.878378 232.791751,168.023634 209.237113,168.176654 L235.835052,185.878378 Z",
    id: "Path",
    fill: "#3F3D56"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2);
export default __webpack_public_path__ + "static/media/work-2.b078cd79f3f01ff1df8486ac61e03c2e.svg";
export { ForwardRef as ReactComponent };